export default "__VITE_ASSET__D$2r83DA__"